import './order-feedback.styles.scss';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import FeedIcon from '@mui/icons-material/Feed';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import BackgroundImg from '../../assets/background-images/obrigado_background.png';

const OrderFeedback = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { vouchers } = state || {};

    const hanldleOpenVoucherClick = () => vouchers.forEach((voucher) => window.open(voucher.url, '_blank'));

    const handleOpenMyOrdersClick = () => navigate('/my-orders');
    
    return (
        <div className='order-feedback-container' style={{backgroundImage: `url(${BackgroundImg})`}}>
            <div className='text-container'>
                <h1 className='title'>Pedido efetuado!</h1>
                <h3 className='subtitle'>Muito obrigado por escolher a Assegurados.<br/>Agora, você poderá viajar em segurança!</h3>
                <span className='text'>Em breve, enviaremos as suas apólices de seguro<br/>viagem para o e-mail informado durante a compra.</span>
                <Button className='button open-my-orders' variant='contained' size='small' onClick={handleOpenMyOrdersClick}>
                    <AccountCircleOutlinedIcon />
                    Acessar minha conta
                </Button>
                {vouchers && (
                <Button className='button open-voucher' variant='contained' size='small' onClick={hanldleOpenVoucherClick}>
                    <FeedIcon />
                    Fazer o download da Apólice
                </Button>
                )}
                <span className='text small'>Desejamos a você uma viagem incrível e segura!</span>
            </div>
        </div>
    )
}

export default OrderFeedback;